import { render, staticRenderFns } from "./ConfluenceOAuthCallback.vue?vue&type=template&id=07b4def8&scoped=true&"
import script from "./ConfluenceOAuthCallback.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ConfluenceOAuthCallback.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ConfluenceOAuthCallback.vue?vue&type=style&index=0&id=07b4def8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b4def8",
  null
  
)

export default component.exports